import PropTypes from "prop-types";
import { Component } from "react";
import { addFieldData, setReturnedValue } from "../actions";
import { connect } from "react-redux";

class Looper extends Component {
  componentDidMount() {
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);
  }

  componentWillUnmount() {
    const dataKey = this.props.step.data.keyValue;
    this.props.resetData(dataKey);
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    resetData: key => dispatch(addFieldData(key, null))
  };
};

Looper.propTypes = {
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      formatSource: PropTypes.func,
      keyValue: PropTypes.any
    })
  }),
  fetchData: PropTypes.func,
  resetData: PropTypes.func
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Looper);
